const CLIENTE_CONSULTAR_CADASTRO = 'CLIENTE_CONSULTAR_CADASTRO';
const CLIENTE_CONSULTAR_CONTRATOS = 'CLIENTE_CONSULTAR_CONTRATOS';
const CLIENTE_CONSULTAR_BOLETOS = 'CLIENTE_CONSULTAR_BOLETOS';

export {CLIENTE_CONSULTAR_CADASTRO, CLIENTE_CONSULTAR_CONTRATOS, CLIENTE_CONSULTAR_BOLETOS}
